import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { showErrorPopup } from '../../actions/notification-actions';
import { verifyUserMagicLink } from '../../actions';

const homePath = '/home';
const onboardingPath = '/onboarding';
const loginPath = '/login';
const platform = 'web';

const MagicLinkVerificationPage = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const authError = useSelector((state) => state.auth?.error);
    const user = useSelector((state) => state.auth?.user);

    const handleOnCloseErrorPopup = () => {
        history.push(loginPath);
    };

    const displayErrorPopup = () => {
        dispatch({ type: 'SPLASH_HIDE' });
        dispatch(showErrorPopup({
            message: 'Something went wrong while verifying your login link',
            onConfirmClick: handleOnCloseErrorPopup,
            onCancelClick: handleOnCloseErrorPopup,
        }));
    };

    useEffect(() => {
        const tokenHash = location?.hash?.split('=')[1];
        if (tokenHash) {
            dispatch(verifyUserMagicLink({ token: tokenHash, platform }));
        } else {
            displayErrorPopup();
        }
    }, []);

    useEffect(() => {
        if (authError) {
            displayErrorPopup();
         }
    }, [authError]);

    useEffect(() => {
        if (user) {
            const { mfaOptions, onboardingRequired, onboardingCompleted } = user;

            if (mfaOptions?.mfaRequired) {
                if (mfaOptions?.mfaEnabled) {
                    history.replace('/mfa');
                } else {
                    history.replace('/mfa-setup');
                }
                return;
            }

            if (onboardingRequired && !onboardingCompleted) {
                history.replace(onboardingPath);
            } else {
                history.replace(homePath);
            }
        }
    }, [user]);

    return null;
};

export default MagicLinkVerificationPage;
